import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactModal from 'react-modal';
import ReactModalActions from 'components/ReactModalActions';
import { Helmet } from 'react-helmet';
import { useToasts } from 'react-toast-notifications';
import H1 from 'components/H1';
import H2 from 'components/H2';
import { Flex, Box, Button } from 'rebass';
import { Input, Select, Label } from '@rebass/forms';
import helpers from 'utils/helpers';
import services from 'services/services';
import service_accounts from 'services/accounts';
import { FiEdit } from 'react-icons/fi';
import moment from 'moment-timezone';

import AppPageWrapper from 'components/AppPageWrapper';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import AppPageWrapperSectionSubHeader from 'components/AppPageWrapper/AppPageWrapperSectionSubHeader';
import SettingsPageSubNav from 'containers/SettingsPage/SettingsPageSubNav';
import AppPageSubnav from 'components/AppPageWrapper/AppPageSubnav';
import ListWrapper from 'components/ListWrapper';
import ItemWrapper from 'components/ItemWrapper';
import InputSearch from 'components/InputSearch';

import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';

function SettingsUsagePage(props) {
    
    const [usageByMonth, setUsageByMonth] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { addToast } = useToasts();

    useEffect(() => {
        getAccountUsageXHR();
    }, []);

    function getAccountUsageXHR() {
        service_accounts.getUsage().then(usage_numbers => {
            setUsageByMonth(usage_numbers);
            setIsLoading(false);
        });
    }

    function renderUsage() {
        let elements = [];
        usageByMonth.forEach(month_usage => {
            elements.push(<ItemWrapper className='text-primary'>
                    <Box width={1 / 4} style={{ marginTop: '6px' }}>
                        {moment(month_usage.start_date).format('MMM YYYY')}
                    </Box>
                    <Box width={1 / 4}>
                        {helpers.numberWithCommas(month_usage.monthly_emails_count)}
                    </Box>
                    <Box width={1 / 4} style={{ marginTop: '6px' }}>
                        {helpers.numberWithCommas(month_usage.total_bulk_sent)}
                    </Box>
                    <Box width={1 / 4}>
                        {helpers.numberWithCommas(month_usage.extra)}
                    </Box>
                </ItemWrapper>
            );
        });

        if (elements.length == 0) {
            elements.push(<Box fontSize={1} m={3}>We dont have any usage recorded.</Box>)
        }

        return elements;
    }

    return (
        <Flex style={{ width: '100%' }}>
            <AppPageWrapper>
                <Helmet>
                    <title>Usage</title>
                </Helmet>
                <AppPageSubnav>
                    <SettingsPageSubNav/>
                </AppPageSubnav>
                <AppPageWrapperSectionHeader className='experience'>
                    <Box>
                        <H1>Usage</H1>
                        <Box className='experience-description'>
                            Your email usage thoughout the month.
                        </Box>
                    </Box>
                </AppPageWrapperSectionHeader>
                <AppPageWrapperSectionBody>
                    <Box mx={4} my={4} width="100%">
                        
                        

                        <ListWrapper
                            style={{
                                position: 'relative',
                                border: '1px solid #eee',
                                borderRadius: '4px'
                            }}
                        >
                            <ItemWrapper className='header-row'>
                                <Box width={1 / 4}>Month</Box>
                                <Box width={1 / 4}>Base Emails</Box>
                                <Box width={1 / 4}>Used</Box>
                                <Box width={1 / 4}>Extra</Box>
                            </ItemWrapper>
                            {isLoading ? (
                                <Box m={3} style={{minHeight: '24px'}}>
                                    <LoadingWrapper>
                                        <LoadingIndicator />
                                    </LoadingWrapper>
                                </Box>
                            ) : renderUsage() }
                        </ListWrapper>
                    </Box>

                </AppPageWrapperSectionBody>
            </AppPageWrapper>
        </Flex>
    );
}

export default SettingsUsagePage;
